import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";

import { Container } from "../Container/Container";
import Select from "../Select/Select";
import Checkbox from "../Checkbox/Checkbox";
import Tag from "../Tag/Tag";
import GetCards from "../GetCards/GetCards";
import Search from "../Search/Search";
import ToggleView from "../ToggleView/ToggleView";
import Logos from "../Logos/Logos";
import { DispatchMessage } from "../DispatchMessage/dispatchMessage";

import { filterSave as filterSaveAction } from "../../store/filterSave/actions";

import { HOST } from "../../store/types";
import Svg from "../../assets/icons/icons";
import { colors as c } from "../../styles/variables";

import {
    GeneralContainerSt,
    MobileOpenFilterSt,
    MobileOpenFilterSvgSt,
    SearchPanelSt,
    HrSt,
    FilterPanelSt,
    FilterContainerSt,
    MobileLogosSt,
    ContainerLogosSt,
    SelectContainerSt,
    SvgTabletSt,
    CheckboxSt,
    TagContainerSt,
    TitleSt,
    MobileSt,
    MobileHalfSt,
    MobileHalfRightSt,
    Container_menu_mobileSt,
    FoundSt,
} from './style.js';

import i18n from "i18next";
import ToggleViewRed from '../ToggleViewRed/ToggleViewRed'


// значения селектов фильтра
const initialFilters = {
    showCategoryFilter: "0",
    showGenreFilter: "0",
    showYearFilter: "0",
    showDurationFilter: "0",
    showQualityFilter: "0",
    showFormatFilter: "0",
    showChannelFilter: "0",
    searchWord: "",
};

// категории и жанры полученные с сервера
const initialFilterMenu = {
    "filter[category_id]": [],
    "filter[genre_id]": [],
    "filter[duration]": [[]],
    "filter[quality]": [],
    "filter[channel_id]": [],
};

// имя селекта -> поле состояния
const selectFieldByName = {
    category: 'showCategoryFilter',
    genre: 'showGenreFilter',
    year: 'showYearFilter',
    duration: 'showDurationFilter',
    quality: 'showQualityFilter',
    format: 'showFormatFilter',
    channel: 'showChannelFilter',
};

// выбран ли хотя бы один фильтр
const isFilterActive = (f) =>
    Boolean(f.searchWord) ||
    f.showCategoryFilter !== "0" ||
    f.showGenreFilter !== "0" ||
    f.showYearFilter !== "0" ||
    f.showDurationFilter !== "0" ||
    f.showQualityFilter !== "0" ||
    f.showFormatFilter !== "0" ||
    f.showChannelFilter !== "0";


const Filter = ({ render, _hiddenContentPage }) => {
    //для переключения режима показа карточек
    const [dashboard, setDashboard] = useState(true);
    // открытие закрытие фильтра
    const [openFilter, setOpenFilter] = useState(window.innerWidth < 768 ? false : true);
    const [tuneFrame, setTuneFrame] = useState(false);
    const [arrowTop, setArrowTop] = useState(false);
    // для работы селектов
    const [closeAllSelect, setCloseAllSelect] = useState(false); // контроль закрытия всех селектов
    // категории и жанры полученные с сервера
    const [filterMenuData, setFilterMenuData] = useState(initialFilterMenu);
    // значение селектов
    const [filters, setFilters] = useState(initialFilters);
    const [renderFilter, setRenderFilter] = useState(false);
    // сортировка результата по названию, false - asc, true - desc
    const [sortFilter, setSortFilter] = useState("asc");
    // выделяем селект (категорию или жанр) если работу фильтра вызывает переход по ссылке "смотреть все"
    const [selectChooseFromLink, setSelectChooseFromLink] = useState(false);
    const [selectValueFromLink, setSelectValueFromLink] = useState(false);
    //
    const [countCards, setCountCards] = useState(-1);
    //
    const [foundMessage, setFoundMessage] = useState(false);

    const dispatch = useDispatch();
    const filterSave = useSelector((store) => store.filterSave.filterSave);
    const filterMenu = useSelector((store) => store.filterSave.filterMenu);
    const location = useLocation();

    // актуальные значения для чтения внутри setTimeout/промисов
    const filtersRef = useRef(filters);
    filtersRef.current = filters;
    const filterMenuDataRef = useRef(filterMenuData);
    filterMenuDataRef.current = filterMenuData;
    const hiddenContentPageRef = useRef(_hiddenContentPage);
    hiddenContentPageRef.current = _hiddenContentPage;

    // таймеры, чтобы почистить их при размонтировании
    const timers = useRef([]);
    const later = (fn, ms) => { timers.current.push(setTimeout(fn, ms)) };
    useEffect(() => () => { timers.current.forEach(clearTimeout) }, []);

    // рендеринг фильтра
    const _filterRender = () => {
        setRenderFilter(false);
        later(() => { setRenderFilter(true) }, 10);
    };

    // В мобильной версии показываем колличество найденных карт
    const _foundShow = () => {
        later(() => { setFoundMessage(true) }, 1500);
        later(() => { setFoundMessage(false) }, 3000);
    };

    // показываем и скрываем результат фильтрации
    const _showSearchingResults = (option, selectName) => {
        _foundShow();
        setCountCards(-1);

        const field = selectFieldByName[selectName];
        if (field) {
            const value = (option === "0" || (selectName === 'year' && option === i18n.t(`filter.year`)))
                ? "0"
                : option;
            setFilters((prev) => ({ ...prev, [field]: value }));
        }

        later(() => {
            hiddenContentPageRef.current(isFilterActive(filtersRef.current));
            _filterRender();
        }, 10);
    };

    //  фильр обрабатывает жанр/категорию при переходе через "смотреть все"
    const filterPostLink = (menu) => {
        const source = menu || filterMenuDataRef.current;

        if (localStorage.getItem('filterStart') !== "") {
            source["filter[category_id]"].map((item) => {
                if (localStorage.getItem('filterStart') === item.title) {
                    _showSearchingResults(item.id, 'category');
                    setSelectChooseFromLink('category');
                    setSelectValueFromLink(localStorage.getItem('filterStart'));
                }
                return item;
            });
            source["filter[genre_id]"].map((item) => {
                if (localStorage.getItem('filterStart') === item.title) {
                    _showSearchingResults(item.id, 'genre');
                    setSelectChooseFromLink('genre');
                    setSelectValueFromLink(localStorage.getItem('filterStart'));
                }
                return item;
            });
            later(() => { setSelectChooseFromLink(false) }, 50);
            localStorage.setItem('filterStart', '')
        }
    };

    const filterPostLinkRef = useRef(filterPostLink);
    filterPostLinkRef.current = filterPostLink;

    // поиск карты по названию
    const _searchCard = (word) => {
        if (word !== "") {
            _hiddenContentPage(true);
            setFilters((prev) => ({ ...prev, searchWord: word }));
        }
        _filterRender();
    };

    const searchCardRef = useRef(_searchCard);
    searchCardRef.current = _searchCard;

    const filterSaveRef = useRef(filterSave);
    filterSaveRef.current = filterSave;

    // componentDidMount: получаем категории и жанры с сервера
    useEffect(() => {
        fetch(`${HOST}/v1/project-navigation-menu`)
            .then((res) => {
                return res.json();
            })
            .then((body) => {
                setFilterMenuData(body);

                // передаём body напрямую: состояние ещё не успело обновиться
                filterPostLinkRef.current(body);

                const saved = filterSaveRef.current;
                const restored = {
                    showCategoryFilter: saved.saveCategoryFilter,
                    showGenreFilter: saved.saveGenreFilter,
                    showYearFilter: saved.saveYearFilter,
                    showDurationFilter: saved.saveDurationFilter,
                    showQualityFilter: saved.saveQualityFilter,
                    showFormatFilter: saved.saveFormatFilter,
                    showChannelFilter: saved.saveChannelFilter,
                    searchWord: saved.saveSearchWord,
                };
                setFilters((prev) => ({ ...prev, ...restored }));

                if (isFilterActive(restored)) {
                    hiddenContentPageRef.current(true)
                }
                searchCardRef.current(saved.saveSearchWord)
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // componentDidUpdate: обработка жанра/категории при изменении пропса render
    const isFirstRenderProp = useRef(true);
    useEffect(() => {
        if (isFirstRenderProp.current) {
            isFirstRenderProp.current = false;
            return;
        }
        filterPostLinkRef.current();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [render]);

    // componentDidUpdate: сохраняем настройки фильтра при их изменении
    const isFirstFilters = useRef(true);
    useEffect(() => {
        if (isFirstFilters.current) {
            isFirstFilters.current = false;
            return;
        }

        if (localStorage.getItem('filterStart')) {
            dispatch(filterSaveAction({
                saveSearchWord: filters.searchWord,
                saveCategoryFilter: filters.showCategoryFilter,
                saveGenreFilter: filters.showGenreFilter,
                saveYearFilter: filters.showYearFilter,
                saveDurationFilter: filters.showDurationFilter,
                saveQualityFilter: filters.showQualityFilter,
                saveFormatFilter: filters.showFormatFilter,
                saveChannelFilter: filters.showChannelFilter
            }))
        }
        else {
            dispatch(filterSaveAction({
                saveCategoryFilter: "0",
                saveChannelFilter: "0",
                saveDurationFilter: "0",
                saveFormatFilter: "0",
                saveGenreFilter: "0",
                saveQualityFilter: "0",
                saveSearchWord: "",
                saveYearFilter: "0"
            }))
        }
    }, [filters, dispatch]);

    // проверяем есть ли хотя бы одна найденная карта. В зависимости от результата выводим нужный текст
    const _countCards = (x) => {
        setCountCards(x);
    };

    // показываем карты как - плитка/список
    const _onToggleViewClick = (x) => {
        setDashboard(x);
    };

    // открытие закрытие фильтра
    const _openFilter = () => {
        setOpenFilter((prev) => !prev);
        setTuneFrame((prev) => !prev);
        setArrowTop((prev) => !prev);
    };

    // при открытии второго селектора закрываем первый
    const _closeAllSelect = () => {
        setCloseAllSelect(true);
        later(() => { setCloseAllSelect(false) }, 50);
    };

    // сортировка результата по названию
    const _sortFilter = () => {
        setSortFilter((prev) => prev === "asc" ? "desc" : "asc");
        _filterRender();
    };

    // скидываем настройки фильтра
    const _clearFilter = () => {
        _hiddenContentPage(false);
        setRenderFilter(false);
        setFilters(initialFilters);
    };

    const {
        showCategoryFilter, showGenreFilter, showYearFilter, showDurationFilter,
        showQualityFilter, showFormatFilter, showChannelFilter, searchWord,
    } = filters;

    let DashboardControl = isFilterActive(filters);
    let FilterStart = (DashboardControl && renderFilter) ? true : false;

    // Все варианты значений выбора
    const category = [i18n.t(`filter.category.${0}.category`), [{ name: i18n.t(`filter.category.${0}.category`), id: "0" }]];
    filterMenuData["filter[category_id]"].map((item, i) => {
        return category[1].push({ name: item.title, id: item.id });
    });
    const genre = [i18n.t(`filter.genre.${0}.genre`), [{ name: i18n.t(`filter.genre.${0}.genre`), id: "0" }]];
    filterMenuData["filter[genre_id]"].map((item, i) => {
        return genre[1].push({ name: item.title, id: item.id });
    });
    const year = [i18n.t(`filter.year`), [i18n.t(`filter.year`)]];
    for (let i = 2000; i < new Date().getFullYear() + 1; i++) {
        year[1].push(i);
    }
    const duration = [i18n.t(`filter.duration.${0}.duration`), [{ name: i18n.t(`filter.duration.${0}.duration`), id: "0" }]];
    filterMenuData["filter[duration]"][0].map((item) => {
        return duration[1].push({ name: item + " " + i18n.t(`filter.duration.${0}.minutes`) + ".", id: item });
    });
    const quality = [i18n.t(`filter.quality`), [{ name: i18n.t(`filter.quality`), id: "0" }]];
    filterMenuData["filter[quality]"].map((item) => {
        return quality[1].push({ name: item.toUpperCase(), id: item });
    });
    const channel = [i18n.t(`filter.channel.${0}.channel`), [{ name: i18n.t(`filter.channel.${0}.channel`), id: "0" }]];
    filterMenuData["filter[channel_id]"].map((item, i) => {
        return channel[1].push({ name: item.title, id: i + 1 });
    });

    // Получаем теги
    const allTags = [
        [i18n.t(`filter.category.${0}.category`), 'category', category[1][showCategoryFilter].name, category[1][showCategoryFilter].id],
        [i18n.t(`filter.genre.${0}.genre`), 'genre', filterMenuData["filter[genre_id]"].map((item) => { if (showGenreFilter === item.id) { return item.title } return undefined }), showGenreFilter],
        [i18n.t(`filter.year`), 'year', showYearFilter, showYearFilter],
        [i18n.t(`filter.duration.${0}.duration`), 'duration', showDurationFilter + " " + i18n.t(`filter.duration.${0}.minutes`), showDurationFilter],
        [i18n.t(`filter.quality`), 'quality', showQualityFilter.toUpperCase(), showQualityFilter],
        ["0", "format", i18n.t(`filter.format`), showFormatFilter],
        [i18n.t(`filter.channel.${0}.channel`), 'channel', channel[1][showChannelFilter].name, channel[1][showChannelFilter].id]
    ];
    const allTagsInsert = allTags.map((item, i) => {
        return (item[3] !== "0" && <span key={i} onClick={() => _showSearchingResults("0", item[1])}><Tag name={item[2]} /></span>);
    });

    // Получаем селекты
    const allSelects = [
        ['category', '160px', category, showCategoryFilter],
        ['genre', '190px', genre, showGenreFilter],
        ['year', '130px', year, showYearFilter],
        ['duration', '160px', duration, showDurationFilter],
        ['quality', '130px', quality, showQualityFilter],
        ['format', '140px', "", showFormatFilter],
        ['channel', '120px', channel, showChannelFilter]
    ];
    const allSelectsInsert = allSelects.map((item, i) => {
        if (item[0] !== 'format') {
            return (
                <SelectContainerSt ContainerWidth={item[1]} key={i}>
                    <Select
                        _closeAllSelect={() => _closeAllSelect()}
                        closeAllSelect={closeAllSelect}
                        _showSearchingResults={(x) => _showSearchingResults(x, item[0])}
                        removeChoice={item[3]}
                        content={item[2]}
                        selectName={item[0]}
                        selectChooseFromLink={selectChooseFromLink ||
                            (item[0] === "category" && filterSave.saveCategoryFilter !== "0") ||
                            (item[0] === "genre" && filterSave.saveGenreFilter !== "0") ||
                            (item[0] === "year" && filterSave.saveYearFilter !== "0") ||
                            (item[0] === "duration" && filterSave.saveDurationFilter !== "0") ||
                            (item[0] === "channel" && filterSave.saveChannelFilter !== "0") ||
                            (item[0] === "quality" && filterSave.saveQualityFilter !== "0")
                        }
                        selectValueFromLink={selectValueFromLink}
                        filterSave={
                            (item[0] === "category" && filterSave.saveCategoryFilter !== "0" && filterMenu["filter[category_id]"].filter((item) => item.id === filterSave.saveCategoryFilter)[0].title) ||
                            (item[0] === "genre" && filterSave.saveGenreFilter !== "0" && filterMenu["filter[genre_id]"].filter((item) => item.id === filterSave.saveGenreFilter)[0].title) ||
                            (item[0] === "year" && filterSave.saveYearFilter !== "0" && filterSave.saveYearFilter) ||
                            (item[0] === "duration" && filterSave.saveDurationFilter !== "0" && filterSave.saveDurationFilter + " " + i18n.t(`filter.duration.${0}.minutes`)) ||
                            (item[0] === "channel" && filterSave.saveChannelFilter !== "0" && filterMenu["filter[channel_id]"].filter((item) => item.id === filterSave.saveChannelFilter)[0].title) ||
                            (item[0] === "quality" && filterSave.saveQualityFilter !== "0" && filterSave.saveQualityFilter.toUpperCase())
                        }
                    />
                </SelectContainerSt>
            );
        }
        else {
            return (
                <SelectContainerSt ContainerWidth={item[1]} key={i}>
                    <CheckboxSt borderActive={filterSave.saveFormatFilter !== "0" && true}>
                        <Checkbox
                            name={i18n.t(`filter.format`)}
                            _showSearchingResults={(x) => _showSearchingResults(x ? "1" : "0", "format")}
                            removeChoice={item[3]}
                            filterSave={filterSave.saveFormatFilter !== "0" && true}
                        />
                    </CheckboxSt>
                </SelectContainerSt>
            )
        }
    });

    return (
        <>
            <GeneralContainerSt>
                <MobileOpenFilterSt onClick={() => _openFilter()} openFilter={openFilter}>{i18n.t(`filter.filters`)}
                    <MobileOpenFilterSvgSt>
                        <Svg className={arrowTop && "keyboard_arrow_top"} type="keyboard_arrow" />
                    </MobileOpenFilterSvgSt>
                </MobileOpenFilterSt>
                <Container>
                    <SearchPanelSt>
                        {(window.innerWidth < 768)
                            ? null
                            : <>
                                <Search
                                    _clearFilter={() => _clearFilter()}
                                    filter={true}
                                    searchWord={searchWord !== ""}
                                    size="90%"
                                    isButtonShow="true"
                                    iconSearch="search"
                                    placeholder={filterSave.saveSearchWord || i18n.t(`filter.add_by_name`)}
                                    searchBoxIsOpen={true}
                                    tune={true}
                                    tuneFrame={!tuneFrame}
                                    _openFilter={() => _openFilter()}
                                    _click={(word) => _searchCard(word)}
                                />
                                {DashboardControl && <ToggleView selected={dashboard ? "dashboard" : "list"} toggleViewChange={(x) => _onToggleViewClick(x)} />}
                                {(!DashboardControl && (location.pathname === "/catalog" || /channel/.test(location.pathname))) && <ToggleViewRed></ToggleViewRed>}
                            </>
                        }
                    </SearchPanelSt>
                    <FilterPanelSt openFilter={openFilter}>
                        <HrSt />
                        <FilterContainerSt>
                            {(window.innerWidth < 768) && <MobileLogosSt>

                                <Container_menu_mobileSt>
                                    <NavLink activeClassName="active" to="/channel/tnt"><Svg width="80" height="36" type="tnt_80_36" color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/tv3"><Svg width="80" height="36" type={i18n.t(`about.logo.${0}.tv3`)} color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/friday"><Svg width="80" height="36" type={i18n.t(`about.logo.${0}.friday`)} color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/2x2"><Svg width="80" height="36" type="2x2_80_36" color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/tnt4"><Svg width="80" height="36" type="tnt4_80_36" color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/subbota"><Svg width="80" height="36" type={i18n.t(`about.logo.${0}.super`)} color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/gpm-etv"><Svg width="80" height="36" type={i18n.t(`about.logo.${0}.gpm`)} color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/2x2prod"><Svg width="80" height="36" type={i18n.t(`about.logo.${0}.tv2x2_anim`)} color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/123-production"><Svg width="80" height="36" type="tv123" color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/comedy-production"><Svg width="80" height="36" type="comedy" color='#42A5F5' /></NavLink>
                                    <NavLink activeClassName="active" to="/channel/good-story"><Svg width="80" height="36" type="good_story" color='#42A5F5' /></NavLink>
                                </Container_menu_mobileSt>

                                <ContainerLogosSt>
                                    <Logos container="header" color={c.blue_active} />
                                </ContainerLogosSt>
                            </MobileLogosSt>}
                            {allSelectsInsert /* вставляем все селекты */}
                            <SvgTabletSt dashboardControl={DashboardControl} ContainerWidth="25px" onClick={() => _sortFilter()}>
                                {i18n.language === 'ru' ? <Svg type="sort_by_alpha_ru" /> : <Svg type="sort_by_alpha_en" />}
                            </SvgTabletSt>
                            <SvgTabletSt dashboardControl={DashboardControl} ContainerWidth="25px" onClick={() => _clearFilter()}>
                                <Svg type="close" />
                            </SvgTabletSt>
                            <MobileSt>
                                <MobileHalfSt>
                                    {DashboardControl && <ToggleView selected={dashboard ? "dashboard" : "list"} toggleViewChange={(x) => _onToggleViewClick(x)} />}
                                    {(!DashboardControl && (location.pathname === "/catalog" || /channel/.test(location.pathname))) && <ToggleViewRed></ToggleViewRed>}
                                </MobileHalfSt>
                                <MobileHalfSt>
                                    <MobileHalfRightSt>
                                        <div><Svg type="sort_by_alpha" /></div>
                                        <div onClick={() => _clearFilter()} style={{ marginLeft: "30px" }}><Svg type="close" /></div>
                                    </MobileHalfRightSt>
                                </MobileHalfSt>
                            </MobileSt>
                        </FilterContainerSt>
                    </FilterPanelSt>
                </Container>
            </GeneralContainerSt>

            <Container padding="true">
                {DashboardControl && <TagContainerSt>
                    <TitleSt>{i18n.t(`filter.searching_results`)}  {searchWord !== "" && (i18n.t(`filter.for`) + ` "${searchWord}"`)}</TitleSt>
                    {allTagsInsert /* вставляем все теги */}
                </TagContainerSt>}
                {FilterStart && <>
                    <GetCards
                        _countCards={(x) => _countCards(x)}
                        sourceCards={`projects?filter%5Bsearch%5D=${searchWord}
                            &filter%5Bcategory_id%5D=${showCategoryFilter}
                            &filter%5Bgenre_id%5D=${showGenreFilter}
                            &filter%5Byear%5D=${showYearFilter}
                            &filter%5Bduration%5D=${showDurationFilter}
                            ${showQualityFilter !== "0" ? ("&filter%5Bquality%5D%5B%5D=" + [showQualityFilter]) : ""}
                            &filter%5Bis_format%5D=${showFormatFilter}
                            &filter%5Bchannel_id%5D=${showChannelFilter}
                            &sort%5Bcolumn%5D=title.${i18n.language}&sort%5Border%5D=${sortFilter}`
                        }
                        type="catalog"
                        cardDisplayType="grid"
                        tile={dashboard}
                        filter={true}
                    />
                </>}
            </Container>
            {(countCards > 0 && foundMessage) && <FoundSt><DispatchMessage message={`${i18n.t(`filter.found_on_request`)} ${countCards} `} /></FoundSt>}
            {(countCards === 0 && foundMessage) && <FoundSt><DispatchMessage message={`${i18n.t(`filter.no_results_found`)}`} /></FoundSt>}
        </>
    );
};

export default Filter;
